import { render } from "./TreePagesMain.vue?vue&type=template&id=21dc8a14"
import script from "./TreePagesMain.vue?vue&type=script&lang=js"
export * from "./TreePagesMain.vue?vue&type=script&lang=js"

import "./TreePagesMain.vue?vue&type=style&index=0&id=21dc8a14&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__